<template>
  <div class="border-b border-neutral-faint p-4">
    <h5
      class="mb-2 text-xs font-semibold tracking-wide text-neutral-subtle uppercase">
      {{ label }}
    </h5>
    <div>
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  label: string;
}>();
</script>
